import React from "react";
import OffCanvas, { OffCanvasHeader, OffCanvasTitle, OffCanvasBody } from "./OffCanvasBase";

function OffCanvasDialog({ isOpen, setOpen, title, placement = "bottom", children,className }) {
  return (
    <OffCanvas setOpen={setOpen} isOpen={isOpen} titleId="offCanvasDialog" placement={placement} className={className}>
      <OffCanvasHeader setOpen={setOpen}>
        <OffCanvasTitle id="offCanvasDialog">{title}</OffCanvasTitle>
      </OffCanvasHeader>
      <OffCanvasBody>{children}</OffCanvasBody>
    </OffCanvas>
  );
}

export default OffCanvasDialog;